import './DownloadDataCard.scss';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


export interface DownloadDataItem {
  fileName: string;
  category: string;
  version: string;
  date: string;
  uploadedFile: string;
  installation?: string;
  machine?: string;
}

const DownloadDataCard = (props: { downloadData: DownloadDataItem }) => {

  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation()

  const docs = [
    {
      uri: require('../../../utils/resources/awayter_connect_light_cropped.png'),
      // uri: '/connect_example.pdf',
      fileType: "png",
      fileName: ''
    }
  ];

  const handleViewClick = () => {
    setShowModal(!showModal)
  }

  const handleDownload = ()=>{
    const fileName = "/AwayterConnectExempleDescarrega"
    const aTag = document.createElement("a")
    aTag.href = "http://localhost:3000/AwayterConnectExempleDescarrega.pdf"
    aTag.setAttribute("download",fileName)
    document.body.appendChild(aTag)
    aTag.click();
    aTag.remove()
  }

  return (
    <div className="download-data-card p-3">
      <div className="d-flex flex-wrap align-items-center text-align-left">
        <div className="flex-fill me-3 mb-sm-2 mb-md-0" style={{ minWidth: "180px", maxWidth: "250px" }}>
          <div className="data-field">
            <div className="field-label">File Name</div>
            <div className="field-value">{props.downloadData.fileName}</div>
          </div>
        </div>

        <div className="me-3 mb-sm-2 mb-md-0" style={{ minWidth: "70px", width: "8%" }}>
          <div className="data-field">
            <div className="field-label">Version</div>
            <div className="field-value">{props.downloadData.version}</div>
          </div>
        </div>

        <div className="me-3 mb-sm-2 mb-md-0" style={{ minWidth: "100px", width: "12%" }}>
          <div className="data-field">
            <div className="field-label">Category</div>
            <div className={"status-badge bg-${categoryColor}"} style={{color: 'var(--text-primary)'}}>
              {props.downloadData.category}
            </div>
          </div>
        </div>

        <div className="me-3 mb-sm-2 mb-md-0" style={{ minWidth: "140px", width: "16%" }}>
          <div className="data-field">
            <div className="field-label">Installation</div>
            <div className={`status-badge bg-${props.downloadData.installation ? "warning" : "secondary"}`}>
              <i className="bi bi-boxes me-1"></i>
              {props.downloadData.installation ? props.downloadData.installation : "No installation"}
            </div>
          </div>
        </div>

        <div className="me-3 mb-sm-2 mb-md-0" style={{ minWidth: "140px", width: "16%" }}>
          <div className="data-field">
            <div className="field-label">Machine</div>
            <div className={`status-badge bg-${props.downloadData.machine ? "info" : "secondary"}`}>
              <i className="bi bi-box me-1"></i>
              {props.downloadData.machine ? props.downloadData.machine : "No machine"}
            </div>
          </div>
        </div>

        <div className="me-3 mb-sm-2 mb-md-0" style={{ minWidth: "80px", width: "10%" }}>
          <div className="data-field">
            <div className="field-label">Date</div>
            <div className="field-value">{props.downloadData.date}</div>
          </div>
        </div>

        <div className="ms-auto d-flex mb-sm-2 mb-md-0">
          <button className="btn btn-IDGreen me-2" style={{ color: 'var(--text-primary)' }} onClick={handleViewClick}>
            <i className="bi bi-eye"></i>
          </button>
          <button className="btn btn-IDGreen" onClick={()=>handleDownload()} style={{ color: 'var(--text-primary)' }}>
            <i className="bi bi-cloud-download"></i>
          </button>
        </div>
        <Modal className="modal-data-card" show={showModal} keyboard={false} backdrop={'static'}  onHide={() => setShowModal(false)} centered >
          <Modal.Header className='text-center' closeButton>
            <Modal.Title>{props.downloadData.fileName}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='modalBody'>
            {/* <DocViewer
                documents={docs}
                pluginRenderers={DocViewerRenderers}
              /> */}
            <iframe
              src="/AwayterConnectExempleDescarrega.pdf"
              width="100%"
              height="600"
            />
          </Modal.Body>
        </Modal>
      </div>

    </div>

  );
}
export default DownloadDataCard;